import React, { useState } from 'react';
import searchIcon from '../../assets/icons/search.svg';
import closeIcon from '../../assets/icons/u_multiply.svg';
import SearchSuggestions from './SearchSuggestions';
import './styles/Search.css';

const SearchBar = ({ 
  searchTerm, 
  onSearchChange, 
  onClearSearch, 
  searchSuggestions, 
  showSuggestions, 
  onSuggestionSelect,
  placeholder = "Search for EV charger"
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    if (searchTerm.length > 0) {
      // This would be handled by parent component
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    // Delay hiding suggestions to allow for clicks
    setTimeout(() => {
      // This would be handled by parent component
    }, 200);
  };

  return (
    <div className="search-input-container">
      <img src={searchIcon} alt="Search" className="search-icon" />
      <input
        className="search-input"
        placeholder={placeholder}
        value={searchTerm}
        onChange={onSearchChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {searchTerm && (
        <img 
          src={closeIcon} 
          alt="Clear search" 
          className="clear-search-icon" 
          onClick={onClearSearch} 
        />
      )}
      {showSuggestions && searchSuggestions.length > 0 && (
        <SearchSuggestions 
          suggestions={searchSuggestions}
          onSelect={onSuggestionSelect}
        />
      )}
    </div>
  );
};

export default SearchBar; 